import { t } from '@lingui/core/macro';
import { TireSeason } from '@navio/nsdk';
import { NoddiSelectableBox } from 'noddi-ui-web';
import { NavioTireSeasonChip } from 'noddi-web';
import { getCommonTranslations } from '../../../utils/commonTranslations';
import { MultiSelectStep } from './MultiSelectStep';
import { getSeasonOptions, getStudsOptions } from './requestOfferOptions';

type Props = {
  selectedSeasons: TireSeason[];
  onSeasonsChange: (seasons: TireSeason[]) => void;
  isStudded: boolean | null;
  onStuddedChange: (isStudded: boolean) => void;
};

/** Which seasons the request is for, and for winter tires whether they are studded. */
export const SeasonStep = ({ selectedSeasons, onSeasonsChange, isStudded, onStuddedChange }: Props) => (
  <>
    <MultiSelectStep
      question={t`Which tires do you need?`}
      options={getSeasonOptions().map(({ value, label }) => ({
        value,
        label: (
          <span className='flex items-center gap-2'>
            <NavioTireSeasonChip season={value} size='sm' iconOnly translations={getCommonTranslations().seasonBadge} />
            {label}
          </span>
        )
      }))}
      selected={selectedSeasons}
      onChange={onSeasonsChange}
    />
    {selectedSeasons.includes(TireSeason.WINTER) && <StudsField isStudded={isStudded} onChange={onStuddedChange} />}
  </>
);

/** Required before the request can go on: offers for winter tires only hold tires with the same answer. */
const StudsField = ({ isStudded, onChange }: { isStudded: boolean | null; onChange: (isStudded: boolean) => void }) => (
  <div className='flex flex-col gap-2 motion-safe:animate-in motion-safe:duration-200 motion-safe:fade-in motion-safe:slide-in-from-top-2'>
    <p className='font-semibold'>{t`Studded or non-studded winter tires?`}</p>
    {/* One choice, so picking another replaces it. */}
    <div className='grid grid-cols-1 gap-1 sm:grid-cols-2'>
      {getStudsOptions().map(({ value, label }) => (
        <NoddiSelectableBox
          key={String(value)}
          aria-pressed={isStudded === value}
          isSelected={isStudded === value}
          setIsSelected={() => onChange(value)}
        >
          {label}
        </NoddiSelectableBox>
      ))}
    </div>
  </div>
);
